import {
	Advertisement,
	AdvertisementAsset,
	AdvertisementAssetType,
	FileResult,
	Template,
} from '@horasys/bellplus/common/types';
import { Mode, TablePaginationResult } from 'store/actions/common';

export const GET_ADVERTISEMENT_DATA_LIST = 'GET_ADVERTISEMENT_DATA_LIST';
export interface GetAllAdvertisementAction {
	type: typeof GET_ADVERTISEMENT_DATA_LIST;
	payload: TablePaginationResult;
}

export const GET_ADVERTISEMENT_DATA_LIST_BY_CLIENT_ID =
	'GET_ADVERTISEMENT_DATA_LIST_BY_CLIENT_ID';
export interface GetAllAdvertisementByClientAction {
	type: typeof GET_ADVERTISEMENT_DATA_LIST_BY_CLIENT_ID;
	payload: Array<Advertisement>;
}
export const RESET_ADVERTISEMENT_FORM = 'RESET_ADVERTISEMENT_FORM';
export interface ResetAdvertisementForm {
	type: typeof RESET_ADVERTISEMENT_FORM;
}

export const UPDATE_ADVERTISEMENT_FORM = 'UPDATE_ADVERTISEMENT_FORM';
export interface UpdateAdvertisementForm {
	type: typeof UPDATE_ADVERTISEMENT_FORM;
	payload: Partial<Advertisement>;
}
export const UPDATE_ADVERTISEMENT_MODE = 'UPDATE_ADVERTISEMENT_MODE';
export interface UpdateAdvertisementModeAction {
	type: typeof UPDATE_ADVERTISEMENT_MODE;
	payload: Mode;
}
export const DELETE_ADVERTISEMENT_ASSET = 'DELETE_ADVERTISEMENT_ASSET';
export interface DeleteAdvertisementAssetAction {
	type: typeof DELETE_ADVERTISEMENT_ASSET;
	payload: AdvertisementAsset;
}

export const GENERATE_ADVERTISEMENT_ASSET = 'GENERATE_ADVERTISEMENT_ASSET';
export interface GenerateAdvertisementAssetFromTemplate {
	type: typeof GENERATE_ADVERTISEMENT_ASSET;
	payload: Template;
}

export const ADVERTISEMENT_ASSET_UPLOAD_COMPLETE = 'ADVERTISEMENT_ASSET_UPLOAD_COMPLETE';
export interface AdvertisementAssetUploadComplete {
	type: typeof ADVERTISEMENT_ASSET_UPLOAD_COMPLETE;
	payload: {
		fileResult: FileResult;
		advertisementAsset: AdvertisementAsset;
		type: AdvertisementAssetType;
		index: number;
	};
}
export const GET_ADVERTISEMENT_BY_ID = 'GET_ADVERTISEMENT_BY_ID';
export const CREATE_ADVERTISEMENT = 'CREATE_ADVERTISEMENT';
export const DELETE_ADVERTISEMENT = 'DELETE_ADVERTISEMENT';
export const UPDATE_ADVERTISEMENT = 'UPDATE_ADVERTISEMENT';

export interface GetAdvertisementByIdAction {
	type: typeof GET_ADVERTISEMENT_BY_ID;
	payload: Advertisement;
}
export type AdvertisementAction =
	| GetAllAdvertisementAction
	| GetAdvertisementByIdAction
	| GetAllAdvertisementByClientAction
	| DeleteAdvertisementAssetAction
	| ResetAdvertisementForm
	| UpdateAdvertisementForm
	| GenerateAdvertisementAssetFromTemplate
	| AdvertisementAssetUploadComplete
	| UpdateAdvertisementModeAction;
